go-overlay.go-dialog {
  --go-overlay-content-padding-y: 1.5rem;
  --go-overlay-content-padding-x: 1.5rem;
  --go-overlay-content-width: 80%;
  --go-overlay-content-bg-color: var(--go-color-bg);
  --go-overlay-content-max-width: 1140px;
  --go-overlay-content-gap: 10vh;
  --go-overlay-close-btn-text-color: currentColor;

  display: grid;
  place-items: center;

  .overlay-content {
    position: relative;
    height: 100%;
    width: 100%;
    padding: var(--go-overlay-content-padding-y) var(--go-overlay-content-padding-x);
    max-width: var(--go-overlay-content-max-width);
    background: var(--go-overlay-content-bg-color);
    @include tablet {
      width: var(--go-overlay-content-width);
      height: auto;
      margin: var(--go-overlay-content-gap) auto;
      border-radius: var(--radius-3);
    }
  }
  .overlay-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .heading{
      font-size: var(--go-size-3);
      font-weight: 500;
      line-height: 1.5;
    }
    .close-btn {
      flex: 0;
    }
  }
}
